module.exports = __webpack_public_path__ + "images/eq-white-playing.ddbf5d0fea2cd7639172a4fedbfd5dac.gif";